import { memo } from 'react';
import sanitizeHtml from 'sanitize-html';
import { FORMS_ENGINE_RICH_TEXT_FIELD_TYPES } from '../../../lib/form.utils';

const Answer = memo(({ user, answer, answerType }) => (
  <p className="spo-a-questionnaire-answer__content-answer">
    <span className="u-text-bold">{user}</span>:{' '}
    {FORMS_ENGINE_RICH_TEXT_FIELD_TYPES.includes(answerType) ? (
      <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(answer) }}></div>
    ) : (
      answer
    )}
  </p>
));

const QuestionnaireAnswer = ({ label, answers }) => {
  return (
    <div className="spo-a-questionnaire-answer">
      <div className="a-input">
        <label className="a-input__label">{label}</label>
        <div className="spo-a-questionnaire-answer__content">
          {answers
            ?.filter((a) => !!a.answer)
            ?.map((a) => (
              <Answer key={a.user} {...a} />
            ))}
        </div>
      </div>
    </div>
  );
};

export default memo(QuestionnaireAnswer);
